import requestApi from "@/utils/requestApi";

export default {
  data() {
    return {
      id: "",
      form: {
        // 结算类型 0: 无账期, 1: 每月固定日, 2: 按账期
        settlementType: 0,
        // 账期
        settlementPeriod: undefined,
        // 授信额度
        settlementLimit: undefined,
      },
      loading: false,
      visible: false,

      rules: {
        settlementPeriod: [{ required: true, message: "请输入", trigger: "change" }],
        settlementLimit: [{ required: true, message: "请输入", trigger: "change" }],
      },
    };
  },
  methods: {
    // 显示
    async open(id) {
      this.id = id;
      this.visible = true;
      this.loading = true;
      const { data } = await requestApi.post("sctrading/purchase/purchasesupplyinfo/selById", { id });
      this.form = {
        settlementType: data.settlementType,
        settlementPeriod: data.settlementPeriod ? data.settlementPeriod : undefined,
        settlementLimit: data.settlementLimit ? data.settlementLimit : undefined,
      };
      this.loading = false;

      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    // 取消
    cancel() {
      this.$refs.form.clearValidate();
      this.$nextTick(() => {
        this.id = "";
        this.visible = false;
      });
    },
    // 确定
    confirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          const { msg, code } = await requestApi.post("sctrading/purchase/purchasesupplyinfo/editById", {
            ...this.form,
            id: this.id,
          });
          this.loading = false;
          if (code == "0") {
            this.$message.success("操作成功");
            this.cancel();
          } else {
            this.$message.error(msg);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
